'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyPage = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = require('babel-runtime/helpers/extends');

var _extends7 = _interopRequireDefault(_extends6);

var _typeToReducer = require('type-to-reducer');

var _typeToReducer2 = _interopRequireDefault(_typeToReducer);

var _mountReducer = require('shared/redux/mountReducer');

var _mountReducer2 = _interopRequireDefault(_mountReducer);

var _types = require('shared/components/Page/types');

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmptyPage = exports.getEmptyPage = function getEmptyPage() {
  return {
    loading: true,
    error: ''
  };
};

var initialState = {
  home: _home.initialState
};

exports.default = (0, _typeToReducer2.default)((0, _extends7.default)({}, (0, _mountReducer2.default)(_home2.default, 'home'), (0, _defineProperty3.default)({}, _types.FETCH_PAGE, {
  PENDING: function PENDING(state, _ref) {
    var meta = _ref.meta;
    return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, meta.path, (0, _extends7.default)({}, getEmptyPage(), {
      loading: true
    })));
  },
  REJECTED: function REJECTED(state, _ref2) {
    var error = _ref2.error,
        meta = _ref2.meta;

    return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, meta.path, {
      loading: false,
      error: error
    }));
  },
  FULFILLED: function FULFILLED(state, _ref3) {
    var response = _ref3.response,
        meta = _ref3.meta;

    return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, meta.path, (0, _extends7.default)({
      error: '',
      loading: false
    }, response)));
  }
})), initialState);


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/pages/index.js
// module id = 1291
// module chunks = 0